<template>
  <div>
    <!--  Login  -->
    <div>
      <section v-if="!isCorrect">
        <div class="columns" style="margin-top: 10%">
          <div class="column is-1"></div>
          <div class="column is-10 is-justify-center" style="display: grid">
            <div class="container box">
              <div>
                <h1 class="has-text-centered is-size-3 has-text-weight-bold">
                  Vista Protegida
                </h1>
                <br />
                <span>Ingresar contraseña</span>
              </div>
              <div class="field has-addons is-justify-center">
                <div class="control is-expanded">
                  <input
                    class="input is-large"
                    v-model="password"
                    v-on:keyup.enter="enviar"
                    type="password"
                    placeholder="Contraseña"
                    autofocus
                  />
                </div>
              </div>
              <a
                class="button is-dark is-large is-fullwidth"
                v-on:click="enviar"
                >Enviar</a
              >
            </div>
          </div>
          <div class="column is-1"></div>
        </div>
      </section>
    </div>
    <div class="is-mobileLider">
      <button
        v-show="isCorrect"
        class="button is-link"
        :class="showMenu ? 'button-lider-open' : 'button-lider-closed'"
        :style="isOculto ? 'margin-left: 83.5%;' : 'margin-left: 97%;'"
        v-on:click="changeMenu"
      >
        <span class="icon"><i class="material-icons">info_outline</i></span>
      </button>
    </div>
    <transition name="fade">
      <div
        v-if="showMenu && sectInter !== ''"
        class="button is-link"
        v-tooltip.left="'Volver atrás'"
        style="top: 80px"
        :class="sectInter !== '' ? 'button-lider-open' : 'button-lider-closed'"
        :style="isOculto ? 'margin-left: 83.5%;' : 'margin-left: 97%;'"
        v-on:click="selectVar('')"
      >
        <span class="icon"><i class="material-icons">arrow_back</i></span>
      </div>
    </transition>
    <div id="cont" v-show="isCorrect">
      <section
        class="columns is-fullheight is-fullwidth"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div class="column" style="transition: all 0.3s ease 0s !important;">
          <div v-if="dataLider" class="container">
            <section class="section">
              <!--  Header  -->
              <section
                id="views"
                class="hero is-light"
                v-if="dataLider.empleado"
              >
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title">{{ dataLider.empleado.nombre }}</h1>
                    <h2 class="subtitle">
                      {{ dataLider.empleado.cargo }} -
                      {{ dataLider.empleado.dependencia }} -
                      {{ dataLider.empleado.email }}
                    </h2>
                  </div>
                </div>
              </section>

              <!--  Date  -->
              <div class="columns fecha">
                <div class="column">
                  <span>Fecha de diagnóstico</span>
                  <h4 class="has-text-dark">
                    {{ dateProcess(infoProcess.date) }}
                  </h4>
                </div>
                <div class="column button-ctx">
                  <a
                    v-if="tokenUser && tokenUser.admin"
                    href="javascript:void(0)"
                    class="button is-small is-dark"
                    :class="this.validCtx ? 'is-loading' : ''"
                    :disabled="this.validCtx"
                    v-on:click="switchContext"
                    style="gap: 5px"
                  >
                    <i class="material-icons">language</i>
                    <span
                      >{{
                        generalContext.status ? "Ocultar" : "Mostrar"
                      }}
                      Contexto general</span
                    >
                  </a>
                </div>
              </div>

              <!-- SubHeader - Cards Info  -->
              <section style="margin-top: 30px">
                <div class="container columns has-text-centered">
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Participación
                      </h1>
                      <span class="is-size-3 has-text-dark" v-if="infoProcess"
                        >{{ infoProcess.participation }}%</span
                      >
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Encuestados
                      </h1>
                      <span class="is-size-4" v-if="infoProcess">{{
                        infoProcess.totalParticipation
                      }}</span>
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Sin Consentimiento
                      </h1>
                      <span class="is-size-4" v-if="infoProcess">{{
                        infoProcess.noConsent
                      }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- SubHeader - General Context -->
              <Transition name="fade">
                <section
                  v-if="generalContext.status"
                  class="content-generalCtx"
                >
                  <div
                    class="ranking"
                    :data-number="generalContext.headers.position"
                  >
                    <img
                      src="@/assets/icons/shield.svg"
                      alt="ranking icon"
                      width="120"
                    />
                    <span
                      v-tooltip.right="
                        'Posición actual frente al total de líderes'
                      "
                      class="tag"
                      >Posición Líder</span
                    >
                  </div>
                  <div class="hero hero-context">
                    <div class="hero-body has-text-centered">
                      <div class="container">
                        <nav class="level">
                          <!-- <div class="iconCtx">
                <img
                  src="@/assets/icons/iconColombia.png"
                  width="80"
                  height="80"
                  alt="colombia"
                />
              </div> -->
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Líderes</p>
                              <p class="title">
                                {{ generalContext.headers.leaders || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Empresas</p>
                              <p class="title">
                                {{ generalContext.headers.clients || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Encuestados</p>
                              <p class="title">
                                {{ generalContext.headers.data || 0 }}
                              </p>
                            </div>
                          </div>
                          <div class="level-item has-text-centered">
                            <div>
                              <p class="heading">Años</p>
                              <p class="title">
                                {{ generalContext.headers.min || "--" }} -
                                {{ generalContext.headers.max || "--" }}
                              </p>
                            </div>
                          </div>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
              </Transition>
            </section>

            <!--  Section Views  -->
            <div id="views">
              <div class="container">
                <section class="section" v-if="dataLider">
                  <ResulLiderParte1
                    ref="childComponent1"
                    :dataLider="dataLider"
                    :generalContext="generalContext"
                  ></ResulLiderParte1>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="showMenu ? 'column is-2' : 'column is-0'"
          style="transition: all 0.3s ease 0s !important;"
        >
          <aside
            :class="showMenu ? 'sidebarLider-show' : 'sidebarLider-none'"
            class="is-narrow-mobile is-fullheight section is-hidden-mobile scroll-light"
            style="overflow-y: scroll"
          >
            <p
              class="has-text-centered is-size-4 has-text-weight-bold has-text-dark"
            >
              Interpretaciones {{ sectInter }}
            </p>
            <br />
            <div v-for="(item, k) in calificaciones" :key="k">
              <transition name="fade">
                <div v-if="sectInter === ''">
                  <br />
                  <div
                    class="tags has-addons"
                    style="cursor: pointer"
                    v-on:click="selectVar(nombres[k])"
                  >
                    <span
                      class="tag is-medium is-dark is-flex"
                      style="width: 100%; justify-content: space-between"
                    >
                      <span></span>
                      <span class="text-dots">{{ nombres[k] }}</span>
                      <span class="icon"
                        ><i class="material-icons is-size-1"
                          >arrow_drop_down</i
                        ></span
                      >
                    </span>
                  </div>
                </div>
              </transition>

              <transition name="fade">
                <div v-if="sectInter === nombres[k]">
                  <div v-for="(itVar, kv) in item" :key="kv">
                    <div class="tags has-addons">
                      <span
                        class="tag is-medium"
                        style="width: 100%; height: 100%; white-space: initial; text-align: center"
                        :class="`rango${kv === 0 ? kv : item.length - kv}`"
                      >
                        {{ nombresRangos[kv] }}
                      </span>
                    </div>
                    <div class="text-justify is-size-7">
                      {{ kv === 0 ? itVar : item[item.length - kv] }}
                    </div>
                    <hr />
                  </div>
                </div>
              </transition>
            </div>
          </aside>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import ResulLiderParte1 from "./ResultadoLider/ResulLiderParte1.vue";
import { mapState } from "vuex";
import json from "./calificacionLider.json";

export default {
  data() {
    return {
      password: "",
      isCorrect: false,
      dataLider: {},
      infoProcess: {},
      processComp: null,
      generalContext: {
        status: false,
        data: {},
        headers: {},
      },
      cambio: 0,
      showMenu: false,
      calificaciones: json.calificaciones,
      nombresRangos: [
        "Sin Resultados",
        "Líder PHD",
        "Líder experta(o)",
        "Líder competente",
        "Líder en desarrollo",
        "Líder con oportunidad de mejora",
        "Líder con prioridad de intervención",
      ],
      nombres: {
        general: "General",
        cond: "Gestión del Conocimiento",
        resuld: "Gestión de Resultados",
        cambiod: "Cambio y Toma de Decisiones",
        logrod: "Logro",
        dsmd: "Gestión de Sí Mismo",
        humid: "Humildad",
        autogd: "Autogestión",
        gperd: "Gestión de Personas",
        reld: "Gestión de Relaciones",
        cefectivad: "Comunicación Efectiva",
        asertivad: "Asertividad",
        cercaniad: "Cercanía",
        rad: "Retroalimentación",
        liderT: "Líder PHD",
      },
      sectInter: "",
    };
  },
  computed: {
    ...mapState(["idtoken", "empresa", "isOculto", "tokenUser"]),
    routestateid() {
      return this.$route.params.liderid;
    },
    validCtx() {
      return (
        this.isEmpty(this.generalContext.data) &&
        this.isEmpty(this.generalContext.headers)
      );
    },
  },
  async beforeMount() {
    if (this.$route.name !== "sharelider") {
      this.isCorrect = true;
      const comparison = await apiServices.get(
        `/getComparison/${this.$route.params.procesoid}`
      );

      if (comparison.data) {
        this.processComp = comparison.data;
      }
    }
  },
  methods: {
    async enviar() {
      let result;
      try {
        if (this.$route.params.relacionid) {
          const data = {
            relacionid: this.$route.params.relacionid,
            liderid: this.$route.params.liderid,
            procesoid: this.$route.params.procesoid,
            password: this.password,
          };
          result = await apiServices.post(`/resultliderfree`, data);

          if (result.data) {
            this.isCorrect = true;
            this.dataLider = result.data;
            this.infoProcess = result.data.infoProcess;

            const campos = Object.keys(this.cambio);
            campos.forEach(function(k) {
              this.cambio[k]++;
            });
          } else {
            this.isCorrect = false;
            await this.$store.dispatch("notify", {
              message: `Contraseña incorrecta`,
              type: "is-danger",
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeData() {
      let result;
      try {
        if (this.$route.name === "sharelider") {
        } else {
          result = await apiServices.get(
            `/resultlider/${this.$route.params.procesoid}/${this.$route.params.liderid}`
          );

          this.dataLider = result.data;
          this.infoProcess = result.data.infoProcess;
          this.cambio === 0 ? (this.cambio = 1) : (this.cambio = 0);
          result.data.cambio = this.cambio;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGeneralContext() {
      try {
        const result = await apiServices.get("/generalContext/1");

        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
          this.generalContext.headers.position = this.getPosition(
            result.data.headers
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // General Context
    switchContext() {
      if (this.validCtx) return;
      this.generalContext.status = !this.generalContext.status;
      this.dataLider.cambio
        ? (this.dataLider.cambio = 0)
        : (this.dataLider.cambio = 1);
    },
    getPosition(headers) {
      const lidert = this.dataLider.colaboradores.liderT.e;
      if (!lidert) return "-";
      const position = headers.ranking.avg_lidert_e.filter(
        (value) => value.avg_lidert_e > lidert
      ).length;
      return position + 1;
    },
    // Others
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        el.scrollIntoView({ behavior: "smooth" });
      });
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    changeMenu() {
      this.showMenu ? (this.showMenu = false) : (this.showMenu = true);
    },
    selectVar(group) {
      if (this.sectInter === group) {
        this.sectInter = "";
      } else {
        this.sectInter = group;
      }
    },
    isEmpty(ele) {
      if (ele === undefined) return true;
      if (typeof ele === "object") return Object.keys(ele).length === 0;
      return ele.length === 0;
    },
  },
  created() {
    if (this.idtoken && !this.$route.params.relacionid) {
      this.getGeneralContext();
      this.traeData();
    }
  },
  watch: {
    isOculto(nv) {
      if (nv) {
        this.showMenu = false;
      }
    },
    isCorrect(nv) {
      if (nv) {
        this.autoScroll();
      }
    },
    idtoken(newv, oldv) {
      if (newv && !this.$route.params.relacionid) {
        this.traeData();
      }
    },
    dataLider(ne) {
      if (ne) this.getGeneralContext();
    },
    showMenu(nv) {
      if (nv && this.isOculto) {
        this.$store.commit("ocultarSide");
      }
    },
  },
  components: {
    ResulLiderParte1,
  },
};
</script>

<style scoped lang="scss">
.is-primary {
  color: #134f5c !important;
}

.is-red {
  color: red;
}

.fecha {
  margin-top: 10px;
  margin-left: 2px;
}

.fecha .is-small {
  border-radius: 4px;
}

.fecha .button-ctx {
  display: flex;
  justify-content: end;
}

.box-sub {
  height: 118px !important;
}

.sidebarLider-show {
  z-index: 50;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: 0;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.sidebarLider-none {
  z-index: 0;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: -300px;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.button-lider-closed {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 97%;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-lider-open {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 79% !important;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.rango1 {
  background-color: #f4cdcd !important;
  color: gray;
}

.rango2 {
  background-color: #facca5 !important;
  color: gray;
}

.rango3 {
  background-color: #fff2cc !important;
  color: gray;
}

.rango4 {
  background-color: #d9ead3 !important;
  color: gray;
}

.rango5 {
  background-color: #a2c4c9 !important;
  color: white;
}

.rango6 {
  background-color: #c8d9f7 !important;
  color: white;
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
}

.text-justify {
  text-align: justify !important;
  text-justify: inter-word !important;
}

.text-dots {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.is-mobileLider {
  @media (max-width: 769px) {
    display: none !important;
  }
}

.content-generalCtx {
  position: relative;
  display: flex;
  margin-top: 25px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    top: -5px;
  }
}

.hero-context {
  border-radius: 10px !important;
  background-color: #d27ff93e !important; // #f3f3f3
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-top: 20px;
    border-top: #510087 solid;
  }
}

.hero-context .hero-body {
  padding: 35px !important;
}

.hero-context .iconCtx {
  border-right: 3px solid #d27ff93e;
  padding-right: 30px;
}

.ranking {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  @media screen and (max-width: 768px) {
    bottom: -39px;
    margin-right: 0 !important;
  }
}

.ranking .tag {
  position: relative;
  background-color: #510087;
  font-weight: 800;
  color: white;
  top: -12px;
}

.ranking::before {
  content: attr(data-number);
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-size: 2rem;
  font-weight: bold;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/ResultLider.vue